import { logEvent, logEventAndFlush } from "./events";
const STATSIG_EVENT_SELECTOR = '[data-statsig-eventable="true"][data-statsig-event]';
const STATSIG_EVENT_NAVIGATION_TIMEOUT_MS = 1000;
const STATSIG_EVENT_RESERVED_DATA_KEYS = new Set([
    "statsigEventable",
    "statsigEvent",
    "statsigValue",
    "statsigSessionReplay",
]);
let statsigEventAttributesBound = false;
export function bindStatsigEventAttributes() {
    if (statsigEventAttributesBound)
        return;
    document.addEventListener("click", handleStatsigEventAttributeClick, true);
    statsigEventAttributesBound = true;
}
function handleStatsigEventAttributeClick(event) {
    const element = getStatsigEventElement(event);
    if (!element)
        return;
    const eventName = element.dataset.statsigEvent?.trim();
    if (!eventName)
        return;
    const link = getStatsigEventLink(element, event);
    const metadata = getStatsigEventMetadata(element, link);
    const value = getStatsigEventValue(element);
    if (!shouldDelayStatsigNavigation(event, link)) {
        logEvent(eventName, value, metadata);
        return;
    }
    event.preventDefault();
    navigateAfterStatsigEvent(eventName, value, metadata, link.href);
}
function getStatsigEventElement(event) {
    const path = typeof event.composedPath === "function" ? event.composedPath() : [];
    for (const item of path) {
        if (item instanceof HTMLElement && item.matches(STATSIG_EVENT_SELECTOR)) {
            return item;
        }
    }
    return event.target instanceof Element
        ? event.target.closest(STATSIG_EVENT_SELECTOR)
        : null;
}
function getStatsigEventLink(element, event) {
    const path = typeof event.composedPath === "function" ? event.composedPath() : [];
    const anchor = path.find((item) => item instanceof HTMLAnchorElement && !!item.href);
    if (anchor) {
        return {
            href: anchor.href,
            target: anchor.target,
            download: anchor.hasAttribute("download"),
        };
    }
    const href = element.getAttribute("href");
    if (!href)
        return null;
    return {
        href: new URL(href, window.location.href).toString(),
        target: element.getAttribute("target") || "",
        download: element.hasAttribute("download"),
    };
}
function getStatsigEventMetadata(element, link) {
    const metadata = {
        page_id: document.documentElement.dataset.pageId || null,
        path: window.location.pathname,
    };
    Object.entries(element.dataset).forEach(([key, value]) => {
        if (!key.startsWith("statsig") || STATSIG_EVENT_RESERVED_DATA_KEYS.has(key) || value == null || value === "")
            return;
        metadata[key] = value;
    });
    const label = (element.textContent || "").replace(/\s+/g, " ").trim();
    if (label) {
        metadata.label = label;
    }
    if (link?.href) {
        try {
            const url = new URL(link.href, window.location.href);
            metadata.destination_origin = url.origin;
            metadata.destination_path = url.pathname;
        }
        catch (_error) {
            metadata.destination_path = link.href;
        }
    }
    return metadata;
}
function getStatsigEventValue(element) {
    const value = element.dataset.statsigValue?.trim();
    return value || null;
}
function shouldDelayStatsigNavigation(event, link) {
    if (!link?.href || link.download || event.defaultPrevented)
        return false;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
        return false;
    if (link.target && link.target.toLowerCase() !== "_self")
        return false;
    try {
        const url = new URL(link.href, window.location.href);
        return url.protocol === "http:" || url.protocol === "https:";
    }
    catch (_error) {
        return false;
    }
}
function navigateAfterStatsigEvent(eventName, value, metadata, href) {
    let didNavigate = false;
    const navigate = () => {
        if (didNavigate)
            return;
        didNavigate = true;
        window.location.href = href;
    };
    window.setTimeout(navigate, STATSIG_EVENT_NAVIGATION_TIMEOUT_MS);
    logEventAndFlush(eventName, value, metadata, STATSIG_EVENT_NAVIGATION_TIMEOUT_MS).finally(navigate);
}
